import Experience from "./Experience/Experience";

const canvas = document.querySelector('#webgl');

const experience = new Experience(canvas);
